"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = void 0;
exports.toISO6392 = toISO6392;
const map = __importStar(require("./iso639.json"));
var Language;
(function (Language) {
    Language["ab"] = "ab";
    Language["aa"] = "aa";
    Language["af"] = "af";
    Language["ak"] = "ak";
    Language["sq"] = "sq";
    Language["am"] = "am";
    Language["ar"] = "ar";
    Language["an"] = "an";
    Language["hy"] = "hy";
    Language["as"] = "as";
    Language["av"] = "av";
    Language["ae"] = "ae";
    Language["ay"] = "ay";
    Language["az"] = "az";
    Language["bm"] = "bm";
    Language["ba"] = "ba";
    Language["eu"] = "eu";
    Language["be"] = "be";
    Language["bn"] = "bn";
    Language["bh"] = "bh";
    Language["bi"] = "bi";
    Language["bs"] = "bs";
    Language["br"] = "br";
    Language["bg"] = "bg";
    Language["my"] = "my";
    Language["ca"] = "ca";
    Language["km"] = "km";
    Language["ch"] = "ch";
    Language["ce"] = "ce";
    Language["ny"] = "ny";
    Language["zh"] = "zh";
    Language["cu"] = "cu";
    Language["cv"] = "cv";
    Language["kw"] = "kw";
    Language["co"] = "co";
    Language["cr"] = "cr";
    Language["hr"] = "hr";
    Language["cs"] = "cs";
    Language["da"] = "da";
    Language["dv"] = "dv";
    Language["nl"] = "nl";
    Language["dz"] = "dz";
    Language["en"] = "en";
    Language["eo"] = "eo";
    Language["et"] = "et";
    Language["ee"] = "ee";
    Language["fo"] = "fo";
    Language["fj"] = "fj";
    Language["fi"] = "fi";
    Language["fr"] = "fr";
    Language["ff"] = "ff";
    Language["gd"] = "gd";
    Language["gl"] = "gl";
    Language["lg"] = "lg";
    Language["ka"] = "ka";
    Language["de"] = "de";
    Language["ki"] = "ki";
    Language["el"] = "el";
    Language["kl"] = "kl";
    Language["gn"] = "gn";
    Language["gu"] = "gu";
    Language["ht"] = "ht";
    Language["ha"] = "ha";
    Language["he"] = "he";
    Language["hz"] = "hz";
    Language["hi"] = "hi";
    Language["ho"] = "ho";
    Language["hu"] = "hu";
    Language["is"] = "is";
    Language["io"] = "io";
    Language["ig"] = "ig";
    Language["id"] = "id";
    Language["ia"] = "ia";
    Language["ie"] = "ie";
    Language["iu"] = "iu";
    Language["ik"] = "ik";
    Language["ga"] = "ga";
    Language["it"] = "it";
    Language["ja"] = "ja";
    Language["jv"] = "jv";
    Language["kn"] = "kn";
    Language["kr"] = "kr";
    Language["ks"] = "ks";
    Language["kk"] = "kk";
    Language["rw"] = "rw";
    Language["kv"] = "kv";
    Language["kg"] = "kg";
    Language["ko"] = "ko";
    Language["kj"] = "kj";
    Language["ku"] = "ku";
    Language["ky"] = "ky";
    Language["lo"] = "lo";
    Language["la"] = "la";
    Language["lv"] = "lv";
    Language["lb"] = "lb";
    Language["li"] = "li";
    Language["ln"] = "ln";
    Language["lt"] = "lt";
    Language["lu"] = "lu";
    Language["mk"] = "mk";
    Language["mg"] = "mg";
    Language["ms"] = "ms";
    Language["ml"] = "ml";
    Language["mt"] = "mt";
    Language["gv"] = "gv";
    Language["mi"] = "mi";
    Language["mr"] = "mr";
    Language["mh"] = "mh";
    Language["ro"] = "ro";
    Language["mn"] = "mn";
    Language["na"] = "na";
    Language["nv"] = "nv";
    Language["nd"] = "nd";
    Language["ng"] = "ng";
    Language["ne"] = "ne";
    Language["se"] = "se";
    Language["no"] = "no";
    Language["nb"] = "nb";
    Language["nn"] = "nn";
    Language["ii"] = "ii";
    Language["oc"] = "oc";
    Language["oj"] = "oj";
    Language["or"] = "or";
    Language["om"] = "om";
    Language["os"] = "os";
    Language["pi"] = "pi";
    Language["pa"] = "pa";
    Language["ps"] = "ps";
    Language["fa"] = "fa";
    Language["pl"] = "pl";
    Language["pt"] = "pt";
    Language["qu"] = "qu";
    Language["rm"] = "rm";
    Language["rn"] = "rn";
    Language["ru"] = "ru";
    Language["sm"] = "sm";
    Language["sg"] = "sg";
    Language["sa"] = "sa";
    Language["sc"] = "sc";
    Language["sr"] = "sr";
    Language["sn"] = "sn";
    Language["sd"] = "sd";
    Language["si"] = "si";
    Language["sk"] = "sk";
    Language["sl"] = "sl";
    Language["so"] = "so";
    Language["st"] = "st";
    Language["nr"] = "nr";
    Language["es"] = "es";
    Language["su"] = "su";
    Language["sw"] = "sw";
    Language["ss"] = "ss";
    Language["sv"] = "sv";
    Language["tl"] = "tl";
    Language["ty"] = "ty";
    Language["tg"] = "tg";
    Language["ta"] = "ta";
    Language["tt"] = "tt";
    Language["te"] = "te";
    Language["th"] = "th";
    Language["bo"] = "bo";
    Language["ti"] = "ti";
    Language["to"] = "to";
    Language["ts"] = "ts";
    Language["tn"] = "tn";
    Language["tr"] = "tr";
    Language["tk"] = "tk";
    Language["tw"] = "tw";
    Language["ug"] = "ug";
    Language["uk"] = "uk";
    Language["ur"] = "ur";
    Language["uz"] = "uz";
    Language["ve"] = "ve";
    Language["vi"] = "vi";
    Language["vo"] = "vo";
    Language["wa"] = "wa";
    Language["cy"] = "cy";
    Language["fy"] = "fy";
    Language["wo"] = "wo";
    Language["xh"] = "xh";
    Language["yi"] = "yi";
    Language["yo"] = "yo";
    Language["za"] = "za";
    Language["zu"] = "zu";
})(Language || (exports.Language = Language = {}));
function toISO6392(language) {
    return map[language];
}
//# sourceMappingURL=language.js.map